import ApiService from "utills/ApiService";
import { useTranslation } from "@refinedev/core";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get } from "lodash";
import { FullScreenLoading } from "components/fullScreenLoading";
import moment from "moment";
import useWindowWidth from "utills/InitWidthDevice";
import Select from 'react-select';
import {
  Button, Typography, Popover,
  PopoverHandler,
  PopoverContent,
} from "@material-tailwind/react";
import { SearchIcon } from "@heroicons/react/outline";
import ConvertCurrency from "utills/convertCurrency";
import { Breadcrumbs } from "components/breadcrumbs";
import Pagination from "components/wps/Pagination";
import './Coupons.scss';
import toast from "react-hot-toast";

const Coupons = () => {
  const { translate, getLocale } = useTranslation();
  const [coupon, setCoupon] = useState('');
  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paging, setPaging] = useState(null as any);
  const [page, setPage] = useState(1);
  const [event, setEvent] = useState(null as any);
  const [status, setStatus] = useState(null as any);
  const [statusID, setStatusID] = useState('');
  const [couponList, setCouponList] = useState([] as any);
  const [filter, setFilter] = useState(true);
  const language = getLocale();
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);
  const status_list = [
    {
      value: '',
      label: translate('all-status')
    },
    {
      value: 'created',
      label: translate('coupon-created')
    },
    {
      value: 'using',
      label: translate('coupon-using')
    },
    {
      value: 'out_of_use',
      label: translate('coupon-out-of-usage')
    },
    {
      value: 'expired',
      label: translate('coupon-expired')
    },
  ] as any;

  const [events, setEvents] = useState([] as any);
  const [eventID, setEventID] = useState('');
  const [fetchData, setFetchData] = useState(false);

  const [searchParams] = useSearchParams();
  const paramsObject = Object.fromEntries([...searchParams]);
  const navigate = useNavigate();
  const [initParams, setInitParams] = useState(true);
  const [token, setToken] = useState('');

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  const breadcrumbItems = [
    {
      label: translate('coupon-management'),
      href: ''
    }
  ];

  useEffect(() => {
    if (initParams) {
      const keys = Object.keys(paramsObject);

      if (keys?.length > 0) {
        handleInitSearchValue();
      } else {
        setFilter(true);
        setInitParams(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams]);

  const handleInitSearchValue = () => {
    if (paramsObject.q && paramsObject.q !== '') {
      setCoupon(paramsObject.q);
    }

    if (paramsObject.event_id && paramsObject.event_id !== '') {
      setEventID(paramsObject.event_id);
    }

    if (paramsObject.status && paramsObject.status !== '') {
      setStatusID(paramsObject.status);
    }

    const intervalInit = setInterval(() => {
      setFilter(true);
      setInitParams(false);
      clearInterval(intervalInit);
    }, 1000);

  }

  useEffect(() => {
    handleUpdateRoute();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupon, eventID, statusID]);

  const handleUpdateRoute = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set('q', coupon);
    newSearchParams.set('event_id', eventID);
    newSearchParams.set('status', statusID);

    const newParamsObject = Object.fromEntries([...newSearchParams]);

    const keys = Object.keys(newParamsObject);
    let changeRoute = false;

    if (keys?.length > 0) {
      keys?.forEach((key: string) => {
        if (newParamsObject[key] !== '') {
          changeRoute = true;
        }
      });
    }

    if (changeRoute || !initParams) {
      navigate(`?${newSearchParams.toString()}`, { replace: true });
    }
  }

  useEffect(() => {
    if (!initParams) {
      if (events?.length > 0) {
        if (eventID !== '') {
          events.forEach((item: any) => {
            if (item?.value === eventID) {
              setEvent(item);
            }
          })
        } else {
          setEvent(events[0]);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams, eventID, events]);

  useEffect(() => {
    if (!initParams) {
      if (status_list?.length > 0) {
        if (statusID !== '') {
          status_list.forEach((item: any) => {
            if (item?.value === statusID) {
              setStatus(item);
            }
          })
        } else {
          setStatus(status_list[0]);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams])

  useEffect(() => {
    if (token !== '') {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [token]);

  useEffect(() => {
    if (fetchData) {
      fetchEventList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const fetchEventList = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`events`, token);

      if (result && result.length > 0) {
        const arr = [] as any;

        result.forEach((item: any) => {
          if (item.id !== 'all') {
            const obj = {
              value: item.id,
              label: get(item, `name_${language}`, '')
            };

            arr.push(obj);
          }
        });

        setEvent(arr[0]);
        setEvents(arr);
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      // toast.error(error.message);
      setLoading(false);
    }
  }

  const TABLE_HEAD = [translate('no'), translate('coupon-code'), translate('max-time-used'), translate('used'), translate('remaining'), translate('discount-condition'), translate('status'), translate('apply-from'), translate('apply-to')];

  useEffect(() => {
    if (events.length > 0 && filter) {
      fetchCouponList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, filter, page]);

  const fetchCouponList = async () => {
    setLoading(true);
    try {
      let id = (eventID !== '') ? eventID : events[0].value;
      const result = await ApiService.get(`promotion/page/${page}?limit=10&q=${coupon}&event_id=${id}&status=${statusID}`, token);

      if (result) {
        setPaging(result.paging);
        setCouponList(result.coupons);
      }
    } catch (error: any) {
      // toast.error(error.message);
    }

    setFilter(false);
    setLoading(false);
  }

  const handleExportData = async () => {
    setLoading(true);

    try {
      let id = (eventID !== '') ? eventID : events[0].value;
      const result = await ApiService.get(`exports/coupon?limit=10&q=${coupon}&event_id=${id}&status=${status.value}`, token);

      if (result) {
        toast.success(translate('export-success'));
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setLoading(false);
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      setFilter(true);
    }
  };

  if (!isMobile) {
    return (
      <div className="coupon-form" onKeyDown={handleKeyDown}>
        <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} title={translate('coupon-management')} />

        <div className="w-full p-[16px]">
          <div className="w-full bg-white rounded-[8px] flex flex-wrap p-[16px] gap-[12px]">
            <div className="w-[calc(50%-12px)] mb-[8px]">
              <div className="text-14 font-500 mb-[8px]">{translate('coupon-code')}</div>

              <input className="border border-[#c5ccd2] rounded-[4px] text-14 h-[38px] w-full"
                placeholder={translate('placeholder-coupon-code')}
                value={coupon}
                onChange={(e: any) => setCoupon(e.target.value)} />
            </div>

            <div className="w-[50%] mb-[8px]">
              <div className="text-14 font-500 mb-[8px]">{translate('event-name')}</div>

              {
                (events.length > 0 && event) &&
                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  value={event}
                  name="events"
                  options={events}
                  className="text-14"
                  classNamePrefix="select"
                  placeholder={events[0].label}
                  onChange={(e: any) => {
                    setEvent(e);
                    setEventID(e.value);
                  }} />
              }

            </div>

            <div className="w-[203px]">
              <div className="text-14 font-500 mb-[8px]">{translate('status')}</div>

              <Select
                styles={{
                  input: (base) => ({
                    ...base,
                    "input:focus": {
                      boxShadow: "none",
                    },
                  })
                }}
                value={status}
                name="status"
                options={status_list}
                className="text-14"
                classNamePrefix="select"
                placeholder={status_list[0].label}
                onChange={(e: any) => {
                  setStatus(e);
                  setStatusID(e.value);
                }} />
            </div>

            {/* <div className="filter-item apply-date">
            <div className="filter-item__label">{translate('apply-date')}</div>

            <DateRangePicker
              quickSelectDate={true}
              mobile={mobile}
              setApplyDate={setApplyDate}
            />
          </div> */}

            <Button
              placeholder="Button search coupon"
              className="w-[136px] h-[38px] flex items-center justify-center rounded-[4px] border border-brand-500 bg-white text-brand-500 mt-[30px]"
              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
              onResizeCapture={() => { }}
              onClick={() => setFilter(true)}>
              <SearchIcon className="w-4 h-4 text-brand-500" />
              <span>{translate('search')}</span>
            </Button>

            <Button
              placeholder="Button export coupon"
              className="px-[16px] h-[38px] flex items-center justify-center rounded-[4px] border border-brand-500 text-white mt-[30px] bg-brand-500"
              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
              onResizeCapture={() => { }}
              onClick={handleExportData}>
              <span>{translate('export-coupons')}</span>
            </Button>
          </div>

          <div className="bg-white rounded-[4px] mt-[12px] w-full p-[16px]">
            <div className="h-full w-full overflow-scroll overflow-y-hidden">
              <table className="w-full min-w-max table-auto text-left">
                <thead className="bg-[#e9ecff]">
                  <tr>
                    {TABLE_HEAD.map((head) => (
                      <th
                        key={head}
                        className="p-4"
                      >
                        <Typography
                          variant="small"
                          className="text-14 font-bold"
                          placeholder="Typography"
                          onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                          onResizeCapture={() => { }}
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    couponList.length > 0 &&
                    couponList.map((item: any, index: number) => {
                      const isLast = index === couponList.length - 1;
                      const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                      return (
                        <tr key={`event_${item.code}_${index}`} className="table-row">
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {
                                index < 9 &&
                                <span>{paging.current_page - 1}{index + 1}</span>
                              }

                              {
                                index === 9 &&
                                <span>{paging.current_page}0</span>
                              }
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {item.code}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                            >
                              {item.max_times_used}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                            >
                              {item.max_times_used - item.remaining}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                            >
                              {item.remaining}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                            >
                              {ConvertCurrency(item.discount_value)}

                              {
                                item.discount_type === 'percent' ?
                                  <span>%</span>
                                  :
                                  <span>VND</span>
                              }
                            </Typography>
                          </td>
                          <td className={classes}>
                            {
                              item.status === 'created' &&
                              <div className="table-body__status created">{translate('coupon-created')}</div>
                            }

                            {
                              item.status === 'using' &&
                              <div className="table-body__status using">{translate('coupon-using')}</div>
                            }

                            {
                              item.status === 'out_of_use' &&
                              <div className="table-body__status out-of-usage">{translate('coupon-out-of-usage')}</div>
                            }

                            {
                              item.status === 'expired' &&
                              <div className="table-body__status expired">{translate('coupon-expired')}</div>
                            }
                          </td>
                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                            >
                              {moment(item.apply_from).format('DD/MM/YYYY HH:mm:ss')}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                              variant="small"
                              color="blue-gray"
                              placeholder="Typography"
                            >
                              {moment(item.apply_to).format('DD/MM/YYYY HH:mm:ss')}
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            {
              paging &&
              <div className="w-full mt-[16px] flex items-center justify-between" id="paginnation-desktop">
                <div className="w-[200px] text-14 font-600">{translate('total')}: {paging.total_item}/{paging.total}</div>

                {
                  paging.total_page > 1 &&
                  <Pagination
                    setPage={setPage}
                    paging={paging}
                    setFilter={setFilter}
                  />
                }
              </div>
            }
          </div>
        </div>

        {
          loading &&
          <FullScreenLoading />
        }
      </div>
    )
  } else {
    return (
      <div className="coupon-form" onKeyDown={handleKeyDown}>
        <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />
        <div className="coupon-form__filter mt-4">
          <div className="w-full h-[64px] flex items-center justify-between px-[16px] bg-white border-b border-[#c5ccd2]">
            <div className="filter__header__label">{translate('coupon-management')}</div>

            <Popover placement="bottom" open={openFilter} handler={setOpenFilter}>
              <PopoverHandler>
                <SearchIcon className="w-5 h-5" />
              </PopoverHandler>
              <PopoverContent onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                onResizeCapture={() => { }}
                className="w-96 !left-[8px]" placeholder="PopoverContent">
                <div className="w-full mb-[16px]">
                  <div className="text-14 font-500 mb-[4px]">{translate('coupon-code')}</div>

                  <input type="text" className="w-full h-[40px] border border-[#c5ccd2] rounded-[4px]"
                    placeholder={translate('placeholder-coupon-code')}
                    onChange={(e: any) => setCoupon(e.target.value)}
                    value={coupon} />
                </div>

                <div className="w-full mb-[16px]">
                  <div className="text-14 font-500 mb-[4px]">{translate('event-name')}</div>

                  {
                    (events.length > 0 && event) &&
                    <Select
                      styles={{
                        input: (base) => ({
                          ...base,
                          "input:focus": {
                            boxShadow: "none",
                          },
                        })
                      }}
                      value={event}
                      name="events"
                      options={events}
                      className="text-14"
                      classNamePrefix="select"
                      placeholder={events[0].label}
                      onChange={(e: any) => {
                        setEvent(e);
                        setEventID(e.value);
                      }} />
                  }

                </div>

                <div className="w-full mb-[16px]">
                  <div className="text-14 font-500 mb-[4px]">{translate('status')}</div>

                  <Select
                    styles={{
                      input: (base) => ({
                        ...base,
                        "input:focus": {
                          boxShadow: "none",
                        },
                      })
                    }}
                    value={status}
                    name="events"
                    options={status_list}
                    className="text-14"
                    classNamePrefix="select"
                    placeholder={status_list[0].label}
                    onChange={(e: any) => {
                      setStatus(e);
                      setStatusID(e.value);
                    }} />
                </div>

                {/* <div className="filter-item">
                  <div className="text-14 font-500 mb-[4px]">{translate('apply-date')}</div>

                  <DateRangePicker
                    quickSelectDate={true}
                    mobile={mobile}
                    setApplyDate={setApplyDate}
                  />
                </div> */}

                <Button
                  placeholder="Button search coupon"
                  className="w-full h-[40px] flex items-center justify-center rounded-[4px] border border-brand-500 text-brand-500"
                  onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                  onResizeCapture={() => { }}
                  onClick={() => {
                    setFilter(true);
                    setOpenFilter(false);
                  }}>
                  <SearchIcon className="w-4 h-4 text-brand-500" />
                  <span>{translate('search')}</span>
                </Button>

                <Button
                  placeholder="Button export coupon"
                  className="w-full h-[40px] flex items-center justify-center rounded-[4px] border border-brand-500 text-white bg-brand-500 mt-[8px]"
                  onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                  onResizeCapture={() => { }}
                  onClick={() => {
                    handleExportData();
                    setOpenFilter(false);
                  }}>
                  <span>{translate('export-coupons')}</span>
                </Button>
              </PopoverContent>
            </Popover>
          </div>

        </div>

        <div className={openFilter ? "my-[16px] mx-[8px] w-[calc(100%-16px)] overlay" : "my-[16px] mx-[8px] w-[calc(100%-16px)]"}>
          <div className="grid grid-cols-1 gap-[8px]">
            {
              couponList.map((item: any, index: number) => {
                return (
                  <div className="bg-white rounded-[8px] p-[16px] w-full" key={`coupon-item-${index}`}>
                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('status')}</div>

                      {
                        (item.status === 'created') &&
                        <div className="coupon-item__row_value text-14 py-[4px] px-[8px] text-12 rounded-[8px] status created">{translate('coupon-created')}</div>
                      }

                      {
                        (item.status === 'using') &&
                        <div className="coupon-item__row_value py-[4px] px-[8px] text-12 rounded-[8px] status using">{translate('coupon-using')}</div>
                      }

                      {
                        (item.status === 'out_of_use') &&
                        <div className="coupon-item__row_value py-[4px] px-[8px] text-12 rounded-[8px]status out-of-usage">{translate('coupon-out-of-usage')}</div>
                      }

                      {
                        (item.status === 'expired') &&
                        <div className="coupon-item__row_value py-[4px] px-[8px] text-12 rounded-[8px] status expired">{translate('coupon-expired')}</div>
                      }
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('no')}</div>
                      <div className="flex-1 text-12">{
                        index < 9 &&
                        <span>{paging.current_page - 1}{index + 1}</span>
                      }

                        {
                          index === 9 &&
                          <span>{paging.current_page}0</span>
                        }</div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('coupon-code')}</div>
                      <div className="flex-1 text-12">{item.code}</div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('max-time-used')}</div>
                      <div className="flex-1 text-12">{item.max_times_used}</div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('used')}</div>
                      <div className="flex-1 text-12">{item.max_times_used - item.remaining}</div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('remaining')}</div>
                      <div className="flex-1 text-12">{item.remaining}</div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('discount-condition')}</div>
                      <div className="flex-1 text-12">
                        {ConvertCurrency(item.discount_value)}

                        {
                          item.discount_type === 'percent' ?
                            <span>%</span>
                            :
                            <span>VND</span>
                        }
                      </div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('apply-from')}</div>
                      <div className="flex-1 text-12">{moment(item.apply_from).format('DD/MM/YYYY HH:mm:ss')}</div>
                    </div>

                    <div className="w-full mb-[8px] flex items-start">
                      <div className="w-[112px] text-14 font-500">{translate('apply-to')}</div>
                      <div className="flex-1 text-12">{moment(item.apply_to).format('DD/MM/YYYY HH:mm:ss')}</div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>

        {
          paging && paging.total_page > 1 &&
          <Pagination
            setPage={setPage}
            paging={paging}
            setFilter={setFilter}
          />
        }

        {
          loading &&
          <FullScreenLoading />
        }
      </div>
    )
  }
};

export default Coupons;